export default [{
  value: 'cash',
  text: 'Efectivo'
}, {
  value: 'mercadopago',
  text: 'Mercado Pago'
}]



// WEBPACK FOOTER //
// ./src/data/paymentMethods.js